
                import { Component } from "/app/packages/open-source/blognami/lib/index.js";
                import { createDecoratorsInclude } from "/app/packages/open-source/blognami/lib/view_file_importers/js.js";
                import { decorators } from "/app/packages/blognami-saas/lib/views/_suspended_banner.js";
                const hash = "ilwfRGYoo6";
                Component.include(createDecoratorsInclude(hash, decorators));
            